import { Row, StatProps, Text } from "@bridgesplit/ui";
import { formatPercent, formatUsd } from "@bridgesplit/utils";

import { ProfitLossText } from "../../common";
import { usePortfolioStats, useActivePortfolioRewardsSummary } from "./util";
import { PortfolioTableStats, RewardPoint } from "./common";
import { COPY } from "../../../constants";

export default function LenderLoanStats() {
    const lendStats = usePortfolioStats()?.lendStats;
    const portfolioRewards = useActivePortfolioRewardsSummary();
    const loading = !lendStats || !portfolioRewards || portfolioRewards.isLoading;

    const stats: StatProps[] = [
        {
            value: <Text translate="no">{formatUsd(lendStats?.totalSupplyUsd)}</Text>,
            caption: "Total supplied"
        },
        {
            value: formatPercent(lendStats?.wAvgApy),
            caption: "Lend APY"
        },
        {
            value: (
                <Row spacing={0.5}>
                    <ProfitLossText variant="body1" profitLossUsd={lendStats?.interestEarnedAllTimeUsd} />
                </Row>
            ),
            caption: COPY.INTEREST_EARNED_LABEL
        },
        {
            value: <Text translate="no">{formatUsd(lendStats?.expected24hInterestUsd)}</Text>,
            caption: COPY.EXPECTED_DAILY_INTEREST_TERM
        },
        {
            value: <RewardPoint points={portfolioRewards?.data?.activeStrategyDailyLendPoints ?? 0} variant="body1" />,
            caption: COPY.DAILY_REWARDS_TERM
        }
    ];
    return <PortfolioTableStats stats={stats} loading={loading} />;
}
